import N8nUserStack from './UserStack.vue';

export default N8nUserStack;
